/**
 * User-facing copy for the in-product help chat, shared by every surface that
 * can show it: the dashboard thread (ChatThread.tsx), the extension thread
 * (HelpChatThread.tsx), and the server route that produces the 409/429 bodies
 * (routes/helpAgent.ts).
 *
 * It lives here because those three packages cannot see each other. Each used
 * to hold its own literal, so a wording change in one diverged from the others
 * with nothing to catch it. `packages/shared/src/__tests__/helpChatCopy.test.ts`
 * fails if any consumer reintroduces an inline copy.
 *
 * No em dashes (project copy rule); the test pins that too.
 */
export const HELP_CHAT_COPY = {
    /** Turn cap reached (server 409 CONVERSATION_FULL). */
    full: "This chat's reached its limit. Start a new one.",
    /** Per-user hourly rate limit (server 429). */
    rate: "You've sent a lot of messages. Try again shortly.",
    /**
     * Anything else the client could not complete, including a network failure
     * and a 401. Client-only: the raw server message is never rendered.
     */
    generic: "Couldn't reach the assistant. Please try again.",
    /**
     * The assistant's opening bubble when the chat is opened by the extension's
     * post-update "Give feedback" button (Emily, 2026-10-08). The broad door
     * is the button; the question is where the specifics are asked for.
     */
    feedbackAsk: "What would make OverlayQA better for you? A feature you wish it had, something that got in your way, anything at all. We'll pass it to the team.",
    /** Composer placeholder while that question is the one on the table. */
    feedbackPlaceholder: 'Share your feedback…',
};
//# sourceMappingURL=helpChatCopy.js.map